module.exports = __webpack_public_path__ + "static/video_bg_01-aed9f6aa83bae7f8f1d1d7d59dd045a6.png";